import { useLoaderData, useNavigate } from "react-router-dom";
import CupDisplay from "../../components/track-components/CupDisplay";
import Button from "../../../shared/components/Button/Button";
import "../../../shared/pages/Browse/SharedBrowse.css";
import "./Browse.css";
import { useLayoutEffect, useState, useEffect } from "react";
import SmallPop from "../../../shared/components/pops/SmallPop";
import { isMobile } from "react-device-detect";
import { toPng } from "html-to-image";
import { doc, getDoc } from "firebase/firestore";
import { useFirebase } from "../../../contexts/FirebaseContext";

import { ReactComponent as ShareIcon } from "../../../assets/icons/svg/share-svgrepo-com.svg";
import { ReactComponent as DownloadIcon } from "../../../assets/icons/svg/download-minimalistic-svgrepo-com.svg";
import { ReactComponent as UserIcon } from "../../../assets/icons/svg/user-svgrepo-com.svg";


export default function BrowseCupId() {
    const data = useLoaderData();
    const navigate = useNavigate();
    const { firestore } = useFirebase();
    const [smallPop, setSmallPop] = useState();
    const [currentCreatorName, setCurrentCreatorName] = useState(data?.creator);

    // Fetch current displayName from Firestore to handle username changes
    useEffect(() => {
        const fetchCurrentCreatorName = async () => {
            if (data?.creatorId) {
                const userDoc = await getDoc(doc(firestore, "users", data.creatorId));
                if (userDoc.exists()) {
                    setCurrentCreatorName(userDoc.data().displayName);
                }
            }
        };
        fetchCurrentCreatorName();
    }, [data?.creatorId, firestore]);

    useLayoutEffect(() => {
        const timeout = setTimeout(() => {
            setSmallPop(null);
        }, 3500);

        return () => clearTimeout(timeout);
    }, [smallPop]);


    return <div id="main-container">
        <div id="found-cup-container" className="cup-card">
            {data?.tracks.length > 0 && <>
                <div className="cup-header">
                    <h3>{data?.cupName}</h3>
                    <Button
                        text={currentCreatorName || "Unknown Creator"}
                        icon={UserIcon}
                        variant="mk8dx"
                        color="blue"
                        onClick={() => navigate(`/profile/${currentCreatorName}`, { state: { from: 'mk8dx' } })}
                    />
                </div>

                <CupDisplay tracks={data?.tracks} variant="browse" showEmblems={true} />

                <div className="share-actions">
                    <Button
                        text="Share"
                        icon={ShareIcon}
                        disabled={!data?.id.length}
                        onClick={(e) => {
                            e.preventDefault();
                            navigator.clipboard.writeText("https://mk8dx-cup-builder.web.app"
                                + `/mk8dx/browse/cup/${data?.id}`);
                            setSmallPop(true);
                        }} />

                    {!isMobile && <Button
                        text="Download Cup Image"
                        icon={DownloadIcon}
                        onClick={() => {
                            const cupElement = document.querySelector(".cup-outline");
                            if (!cupElement) return;

                            toPng(cupElement)
                                .then((dataUrl) => {
                                    const link = document.createElement("a");
                                    link.download = `${data?.cupName}.png`
                                    link.href = dataUrl;
                                    link.click();
                                })
                        }}
                    />}
                </div>
            </>}

            {
                smallPop && <SmallPop text="Copied URL to clipboard!" onClose={() => setSmallPop(null)} />
            }
        </div>
    </div>;
}